import { FormButton } from '@components/Form';
import { styled } from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: ${({ theme }) => theme.sizes.sm};
`;

export const ModalContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.neutral};
  border-radius: 8px;
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow:
    0 4px 6px rgba(0, 0, 0, 0.1),
    0 2px 4px rgba(0, 0, 0, 0.06);
  overflow: hidden;
`;

export const ModalHeader = styled.div`
  padding: ${({ theme }) => theme.sizes.sm};
  border-bottom: 1px solid ${({ theme }) => theme.colors.neutral200};
  margin: 0;
  font-size: ${({ theme }) => theme.sizes.sm};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.neutral800};
`;

export const ModalContent = styled.div`
  padding: ${({ theme }) => theme.sizes.sm};
  flex: 1;
  overflow-y: auto;
  color: ${({ theme }) => theme.colors.neutral900};
`;

export const ModalFooter = styled.div`
  padding: ${({ theme }) => theme.sizes.sm};
  border-top: 1px solid ${({ theme }) => theme.colors.neutral200};
  display: flex;
  gap: ${({ theme }) => theme.sizes.md};
  justify-content: flex-end;
`;

export const Button = styled(FormButton)`
  width: 100%;
  height: 36px;
`;
